import { nanoid } from 'nanoid';
import { ResourceType } from '@/types/resources';
import { parameterize } from '@/utilities';

const generateEditorId = (resourceType, resourceId, teamId) => {
  const newPageResource = resourceType === ResourceType.Page && resourceId === 'newpage';
  const newComment = resourceId === 'new comment';
  return `${teamId}-editor-${parameterize(resourceType)}-${parameterize(resourceId)}${
    newPageResource || newComment ? '-' + nanoid(6) : ''
  }`;
};

export { generateEditorId };
